import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import AuthSliceReducer from "./AuthSlice";
import CommonSliceReducer from "./CommonSlice";
import SendMessageSliceReducer from "./SendMessageSlice";
import ProviderSliceReducer from "./ProviderSlice";
import UserSliceReducer from "./UserSlice";
import ErrorCodeSliceReducer from "./ErrorCodeSlice";
import StarProviderSliceReducer from "./StarProviderSlice";
import NetworkProviderSliceReducer from "./NetworkProviderSlice";
import NocProviderSliceReducer from "./NocProviderSlice";
import SupportProviderSliceReducer from "./SupportProviderSlice";
import SendEmailSupportSliceReducer from "./SendEmailSupportSlice";
import PortingReportSliceReducer from "./PortingReportsSlice";
import WebHookeSliceReducer from "./WebHookSlice";
import SIMManagementSliceReducer from "./SIMManagementSlice";
import CompanyManagementSliceReducer from "./CompanyManagementSlice";
import CompanyNumberManagementSliceReducer from "./CompanyNumberManagementSlice";

const store = configureStore({
  reducer: {
    AUTH: AuthSliceReducer,
    COMMON: CommonSliceReducer,
    SEND_MESSAGE: SendMessageSliceReducer,
    PROVIDER: ProviderSliceReducer,
    USERS: UserSliceReducer,
    ERROR_CODE: ErrorCodeSliceReducer,
    STAR_PROVIDER: StarProviderSliceReducer,
    NETWORK_PROVIDER: NetworkProviderSliceReducer,
    NOC_PROVIDER: NocProviderSliceReducer,
    SUPPORT_PROVIDER: SupportProviderSliceReducer,
    SEND_EMAIL_SUPPORT: SendEmailSupportSliceReducer,
    PORTING_REPORT: PortingReportSliceReducer,
    WEB_HOOK: WebHookeSliceReducer,
    SIM_MANAGEMENT: SIMManagementSliceReducer,
    COMPANY_MANAGEMENT: CompanyManagementSliceReducer,
    COMPANY_NUMBER_MANAGEMENT: CompanyNumberManagementSliceReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<any>
>;

export default store; // Export the store as the default export
